import i18n from '@/utils/i18n';
import React from 'react';
import WarningIcon from '@assets/icons/warning.svg';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';

export const SalesPortalNotFoundScreen: React.FC = () => {
  const [styles, theme] = useStyles();
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const handleReturnToIndex = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: SALES_PORTAL_ROUTES.OrderEntry }],
    });
  };

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={i18n.t('sales_portal.not_found.return_to_index')}
          onPress={handleReturnToIndex}
          size={ButtonSize.Small}
          style={styles.button}
          variant={ButtonVariant.Primary}
        >
          {i18n.t('sales_portal.not_found.return_to_index')}
        </Button>
      }
      description={i18n.t('sales_portal.not_found.description')}
      iconElement={
        <WarningIcon
          fill={theme.sk.color.icon.primary}
          height={48}
          width={48}
        />
      }
      title={i18n.t('sales_portal.not_found.title')}
    />
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
